import CartItem from '@/api/resources/cartItem';
import i18n from '@/plugins/i18n';

const state = {
  cartItems: [],
  validationResult: null,
};

const getters = {
  getCartItems: () => (state.cartItems),
  getValidationResult: () => (state.validationResult),
  getCartItem: () => (state.cartItem),
  getAmountCartItems: () => (state.cartItems.length),
};

const actions = {
  /* eslint-disable camelcase */
  addToCart({ dispatch, getters: storeGetters }, payload) {
    const {
      redirectTo,
      include_related_offers,
      ...params
    } = payload;

    const requestPayload = {
      ...params,
    };

    if (include_related_offers) {
      requestPayload.include_related_offers = true;
    }

    return CartItem.create(requestPayload).then(() => {
      dispatch('addSuccessMessage', i18n.t('success.added_to_cart'));
      dispatch('fetchCartItems');
      dispatch('closeRelatedOffersCartDialog');

      return { success: true, redirectTo: redirectTo || null };
    }).catch(({ response }) => {
      const relatedOffers = response && response.data && response.data.related_offers;

      if (relatedOffers && relatedOffers.length > 0) {
        dispatch('openRelatedOffersCartDialog', {
          relatedOffers,
          pendingCreditOfferedId: params.credit_offered_id,
          redirectTo: redirectTo
            || storeGetters.getRelatedOffersRedirectTo,
        });
      }

      return { success: false, redirectTo: null };
    });
  },

  addAllRelatedOffersToCart({ dispatch, getters: storeGetters }) {
    return dispatch('addToCart', {
      credit_offered_id: storeGetters.getPendingCreditOfferedId,
      include_related_offers: true,
      redirectTo: storeGetters.getRelatedOffersRedirectTo,
    });
  },
  /* eslint-enable camelcase */
  fetchCartItems({ commit }, payload) {
    CartItem.index(payload).then((response) => {
      commit('setCartItems', response);
    });
  },

  deleteCartItem({ dispatch }, payload) {
    CartItem.delete(payload.id).then(() => {
      dispatch('fetchCartItems');
      dispatch('removeLoading');
    });
  },

  updateCartItem({ dispatch }, payload) {
    CartItem.update(payload).then(() => {
      dispatch('fetchCartItems');
      dispatch('removeLoading');
    });
  },

  validateCartItems({ commit, dispatch }) {
    return CartItem.validateItems().then((response) => {
      commit('setValidationResult', response);
      dispatch('fetchCartItems');
    });
  },
};

const mutations = {
  setCartItems($state, payload) {
    const stateCopy = $state;
    stateCopy.cartItems = payload;
  },
  setValidationResult($state, payload) {
    const stateCopy = $state;
    stateCopy.validationResult = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
